/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize AppointmentsCalendar View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AppointmentsCalendarView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsAppointmentsCalendar = mapStateToProps;
export const mapDispatchToPropsAppointmentsCalendar = mapDispatchToProps;

export default connect(
  mapStateToPropsAppointmentsCalendar,
  mapDispatchToPropsAppointmentsCalendar
)(View);
